import { Route, Routes } from "react-router-dom";
import Login from "../pages/auth/Login";
import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "../pages/dashboard/Dashboard";
import AuthLayout from "../layouts/AuthLayout";
import MainLayout from "../layouts/MainLayout";
import Register from "../pages/auth/Rgister";
import IdCards from "../pages/idCards/IdCards";
import EquipmentCertificates from "../pages/equipmentCertificates/EquipmentCertificates";
import Users from "../pages/users/Users";
import Employees from "../pages/employees/Employees";
import EmployeeTracking from "../pages/employees/EmployeeTracking";
import TeamMembers from "../pages/teamMembers/TeamMembers";
import OurClients from "../pages/ourClients/OurClients";
import OurProjects from "../pages/ourProjects/OurProjects";

const AppRoutes = () => {
  return (
    <Routes>
      {/* AUTH ROUTES */}

      <Route element={<AuthLayout/>}>
        <Route path="/" element={<Login />} />
         <Route path="/register" element={<Register />} />
      </Route>

      {/* PROTECTED ROUTES */}

      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/id-cards" element={<IdCards />} />
        <Route path="/equipment-certificates" element={<EquipmentCertificates />} />
        <Route
          path="/users"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employees"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <Employees />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employees/:id/tracking"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <EmployeeTracking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/team-members"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <TeamMembers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/our-clients"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <OurClients />
            </ProtectedRoute>
          }
        />
        <Route
          path="/our-projects"
          element={
            <ProtectedRoute roles={["Admin"]}>
              <OurProjects />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
};

export default AppRoutes;